import { useState } from "react";
import { Link, NavLink } from "react-router-dom";
import { Phone, Menu, X } from "lucide-react";

const NAV = [
  { to: "/", label: "Accueil", id: "accueil" },
  { to: "/terrain-fibre", label: "Raccordement fibre", id: "terrain" },
  { to: "/qualite-controle", label: "Inspection & qualité", id: "qualite" },
  { to: "/sous-traitance-fibre-optique", label: "Sous-traitance", id: "soustraitance" },
  { to: "/realisations", label: "Réalisations", id: "realisations" },
  { to: "/faq", label: "FAQ", id: "faq" },
  { to: "/contact", label: "Contact", id: "contact" },
];

const Logo = () => (
  <Link to="/" className="flex items-center gap-3" data-testid="header-logo">
    <span className="grid h-9 w-9 grid-cols-2 grid-rows-2">
      <span className="bg-midnight" />
      <span className="bg-ciel" />
      <span className="bg-terrain" />
      <span className="bg-qualite" />
    </span>
    <span className="font-display text-xl font-extrabold tracking-tight text-midnight">
      ATLAS <span className="text-ciel">THD</span>
    </span>
  </Link>
);

const Header = () => {
  const [open, setOpen] = useState(false);

  return (
    <header className="sticky top-0 z-50 border-b border-line bg-white/95 backdrop-blur-sm" data-testid="site-header">
      <div className="mx-auto flex h-16 max-w-7xl items-center justify-between px-4 sm:px-6 lg:px-8">
        <Logo />
        <nav className="hidden items-center gap-6 lg:flex" data-testid="header-nav">
          {NAV.map((item) => (
            <NavLink
              key={item.to}
              to={item.to}
              data-testid={`nav-${item.id}`}
              className={({ isActive }) =>
                `text-sm font-medium tracking-wide transition-colors duration-200 hover:text-midnight ${
                  isActive ? "text-midnight underline decoration-terrain decoration-2 underline-offset-8" : "text-steel"
                }`
              }
            >
              {item.label}
            </NavLink>
          ))}
        </nav>
        <div className="hidden items-center gap-3 lg:flex">
          <a
            href="tel:+33605765066"
            data-testid="header-call-button"
            className="hidden items-center gap-2 border border-midnight px-4 py-2 text-sm font-semibold text-midnight transition-colors duration-200 hover:bg-midnight hover:text-white xl:flex"
          >
            <Phone className="h-4 w-4" />
            06 05 76 50 66
          </a>
          <Link
            to="/contact"
            data-testid="header-devis-button"
            className="bg-ciel px-4 py-2 text-sm font-semibold text-midnight transition-colors duration-200 hover:bg-midnight hover:text-white"
          >
            Parlez-nous de votre besoin
          </Link>
        </div>
        <button
          className="p-2 text-midnight lg:hidden"
          onClick={() => setOpen(!open)}
          data-testid="mobile-menu-toggle"
          aria-label="Ouvrir le menu"
        >
          {open ? <X className="h-6 w-6" /> : <Menu className="h-6 w-6" />}
        </button>
      </div>
      {open && (
        <div className="border-t border-line bg-white lg:hidden" data-testid="mobile-menu">
          <nav className="flex flex-col px-4 py-4">
            {NAV.map((item) => (
              <NavLink
                key={item.to}
                to={item.to}
                onClick={() => setOpen(false)}
                data-testid={`mobile-nav-${item.id}`}
                className="border-b border-line py-3 text-sm font-medium text-midnight last:border-0"
              >
                {item.label}
              </NavLink>
            ))}
            <a
              href="tel:+33605765066"
              data-testid="mobile-call-button"
              className="mt-4 flex items-center justify-center gap-2 border border-midnight px-4 py-3 text-sm font-semibold text-midnight"
            >
              <Phone className="h-4 w-4" />
              06 05 76 50 66
            </a>
            <Link
              to="/contact"
              onClick={() => setOpen(false)}
              data-testid="mobile-devis-button"
              className="mt-2 bg-ciel px-4 py-3 text-center text-sm font-semibold text-midnight"
            >
              Parlez-nous de votre besoin
            </Link>
          </nav>
        </div>
      )}
    </header>
  );
};

export default Header;
